/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Paper, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZE } from 'services/constants/env';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { PaginationBlock } from 'ui/PaginationBlock';
import { DATES_ARRAY, DATES_ID } from 'services/constants/dates-constants';
import { getEMerchantRequest } from 'redux/reducers/monthlyFee/reducer';
import styled from '@emotion/styled';
import { TFilters, TOrderBy } from 'redux/types';
import {
	getReceiveVatReimbursementLoading,
	getVatReimbursements,
	getVatReimbursementsLoading,
} from 'redux/reducers/vatReimbursement/selectors';
import {
	getVatReimbursementsRequest,
	receiveVatReimbursementRequest,
	updateCommentRequest,
} from 'redux/reducers/vatReimbursement/reducer';
import { EasTable } from 'ui/EasTable';
import { TTableStructure, ESortDirection } from 'ui/EasTable/types';
import { TVatReimbursementItem } from 'redux/reducers/vatReimbursement/types';
import { EasTableFilterPanel } from 'ui/EasTableFilterPanel';
import { vatReimbursementStructure } from './vat-reimbursement-structure';
import { TVatReimbursementStructure } from './types';
import { ConfirmationWithCommentDialog } from './ConfirmationWithCommentDialog';
import { EasTableWithFilter } from '../../ui/EasTableWithFilter';

export const VatReimbursement: FC = () => {
	const tableStructure = vatReimbursementStructure as TVatReimbursementStructure[];
	const items = useSelector(getVatReimbursements);
	const itemsIsLoading = useSelector(getVatReimbursementsLoading);
	const receiveVatReimbursementIsLoading = useSelector(getReceiveVatReimbursementLoading);

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(
			getVatReimbursementsRequest({
				pageSize: PAGE_SIZE,
				pageNumber: 1,
				searchString: '',
			}),
		);
	}, [dispatch]);

	const { search } = useLocation();
	const location = useLocation();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);
	const navigateParamsWithoutPage = tableStructure.reduce((acc, item) => {
		if (!!navigateParams[item.selector] && item.type === 'date') {
			const dates = DATES_ARRAY.find((i) => i.id === navigateParams[item.selector]);
			if (navigateParams[item.selector] === DATES_ID.CUSTOM_RANGE) {
				if (navigateParams[`${String(item.selector)}StartDate`]) {
					acc.push({
						fieldName: item.selector,
						value: navigateParams[`${String(item.selector)}StartDate`] as string,
						operator: '>=',
					});
				}
				if (navigateParams[`${String(item.selector)}EndDate`]) {
					acc.push({
						fieldName: item.selector,
						value: navigateParams[`${String(item.selector)}EndDate`] as string,
						operator: '<=',
					});
				}
				return acc;
			}
			if (dates?.from) {
				acc.push({
					fieldName: item.selector,
					value: dates.from,
					operator: '>=',
				});
			}
			if (dates?.to) {
				acc.push({
					fieldName: item.selector,
					value: dates.to,
					operator: '<=',
				});
			}
			if (navigateParams[item.selector] === 'empty') {
				acc.push({
					fieldName: item.selector,
					value: 'null',
					operator: '=',
				});
			}
			if (navigateParams[item.selector] === 'notEmpty') {
				acc.push({
					fieldName: item.selector,
					value: 'null',
					operator: '<>',
				});
			}
			return acc;
		}
		// if (
		// 	navigateParams[item.selector] &&
		// 	item.selector === 'status' &&
		// 	navigateParams.status === 'Not Fixed'
		// ) {
		// 	acc.push({
		// 		fieldName: 'status',
		// 		value: 'Fixed',
		// 		operator: '<>',
		// 	});
		// }
		if (navigateParams[item.selector] === 'empty') {
			acc.push({
				fieldName: item.selector,
				value: 'null',
				operator: '=',
			});
		} else if (navigateParams[item.selector] === 'notEmpty') {
			acc.push({
				fieldName: item.selector,
				value: 'null',
				operator: '<>',
			});
		} else if (navigateParams[item.selector])
			acc.push({
				fieldName: item.selector,
				value: navigateParams[item.selector] as string,
				operator: '=',
			});
		return acc;
	}, [] as TFilters);

	// const items?.data = useSelector(getErrorCorrectionsList);
	// const itemsIsLoading = useSelector(getErrorCorrectionsLoader);
	const [selectedRow, setSelectedRow] = useState<number | null>(null);
	const [checkedRows, setCheckedRows] = useState<boolean[]>(() => {
		if (!items?.data) return [];
		return Array.isArray(items.data) ? items.data.map(() => false) : [];
	});
	const [checkedAll, setCheckedAll] = useState(false);
	const [checkedIds, setCheckedIds] = useState<number[]>([]);

	// useEffect(() => {
	// 	setCheckedRows(items?.data?.map(() => false) ?? []);
	// 	setCheckedAll(false);
	// 	setCheckedIds([]);
	// }, [items?.data]);

	// const handleCheckAll = (checked: boolean) => {
	// 	setCheckedAll(checked);
	// 	setCheckedRows(items?.data.map(() => checked) ?? []);
	// 	if (checked) setCheckedIds(items?.data.map((item) => item.internalInvoiceId) ?? []);
	// 	else setCheckedIds([]);
	// };

	// const handleCheckRow = (index: number, checked: boolean) => {
	// 	const newCheckedRows = [...checkedRows];
	// 	newCheckedRows[index] = checked;
	// 	setCheckedRows(newCheckedRows);
	// 	if (items?.data[index].internalInvoiceId) {
	// 		if (checked) setCheckedIds([...(checkedIds ?? []), items?.data[index].internalInvoiceId]);
	// 		else setCheckedIds(checkedIds.filter((id) => id !== items?.data[index].internalInvoiceId));
	// 	}
	// };

	useEffect(() => {
		const orderBy = [];
		if (navigateParams?.sortIndex) {
			orderBy.push({
				fieldName: navigateParams?.sortIndex
					? tableStructure[+navigateParams.sortIndex].selector
					: 'id',
				direction: navigateParams?.sortDirection
					? String(navigateParams.sortDirection) === 'desc'
						? 'desc'
						: 'asc'
					: 'desc',
			} as TOrderBy);
		}
		orderBy.push({
			fieldName: 'id',
			direction: 'desc',
		} as TOrderBy);

		dispatch(
			getVatReimbursementsRequest({
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				filters: navigateParamsWithoutPage as TFilters,
				searchString: String(navigateParams?.search ?? ''),
				orderBy,
			}),
		);
		dispatch(getEMerchantRequest());
	}, [dispatch, location.search]);

	// const filtersArray: TFilter[] = tableStructure.reduce((acc, item) => {
	// 	if (navigateParams[item.selector])
	// 		acc.push({ name: item.selector, value: navigateParams[item.selector] as string });
	// 	return acc;
	// }, [] as { name: string; value: string }[]);

	const [comment, setComment] = useState('');

	const [openReceiveDialog, setOpenReceiveDialog] = useState(false);
	const [openAddCommentDialog, setOpenAddCommentDialog] = useState(false);
	const closeReceiveDialog = () => setOpenReceiveDialog(false);
	const closeAddCommentDialog = () => setOpenAddCommentDialog(false);
	const handleOpenReceiveDialog = (id: number) => {
		setOpenReceiveDialog(true);
		setSelectedRow(id);
	};
	const handleOpenAddCommentDialog = (id: number) => {
		setOpenAddCommentDialog(true);
		setSelectedRow(id);
	};

	const handleReceiveConfirm = () => {
		dispatch(
			receiveVatReimbursementRequest({
				id: selectedRow ?? 0,
				body: { text: comment },
				getVatReimbursementsRequest: {
					pageNumber: page ? +page : 1,
					pageSize: PAGE_SIZE,
					filters: navigateParamsWithoutPage as TFilters,
					searchString: String(navigateParams?.search ?? ''),
					orderBy: [
						{
							fieldName: navigateParams?.sortIndex
								? tableStructure[+navigateParams.sortIndex].selector
								: 'id',
							direction: navigateParams?.sortDirection
								? navigateParams.sortDirection === ESortDirection.DESC
									? ESortDirection.DESC
									: ESortDirection.ASC
								: ESortDirection.DESC,
						},
					],
				},
			}),
		);
		closeReceiveDialog();
	};

	const handleAddCommentConfirm = () => {
		dispatch(
			updateCommentRequest({
				id: selectedRow ?? 0,
				body: { text: comment },
				getVatReimbursementsRequest: {
					pageNumber: page ? +page : 1,
					pageSize: PAGE_SIZE,
					filters: navigateParamsWithoutPage as TFilters,
					searchString: String(navigateParams?.search ?? ''),
					orderBy: [
						{
							fieldName: navigateParams?.sortIndex
								? tableStructure[+navigateParams.sortIndex].selector
								: 'id',
							direction: navigateParams?.sortDirection
								? navigateParams.sortDirection === ESortDirection.DESC
									? ESortDirection.DESC
									: ESortDirection.ASC
								: ESortDirection.DESC,
						},
					],
				},
			}),
		);
		closeAddCommentDialog();
	};

	const handleAction = (id: number, action: string) => {
		if (action === 'Receive') {
			handleOpenReceiveDialog(id);
		} else if (action === 'Add Comment') {
			handleOpenAddCommentDialog(id);
		}
	};

	useEffect(() => {
		if (openReceiveDialog) {
			setComment(items?.data?.find((item) => item.id === selectedRow)?.comments ?? '');
		}
	}, [openReceiveDialog]);
	useEffect(() => {
		if (openAddCommentDialog) {
			setComment(items?.data?.find((item) => item.id === selectedRow)?.comments ?? '');
		}
	}, [openAddCommentDialog]);

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TVatReimbursementItem>
				tableStructure={tableStructure as TTableStructure<keyof TVatReimbursementItem>[]}
				items={items}
				itemsIsLoading={itemsIsLoading}
				handleAction={handleAction}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Typography variant="body1" color="primary" fontWeight="bold">
						VAT Reimbursement
					</Typography>
				</Box>
			</EasTableWithFilter>
			<ConfirmationWithCommentDialog
				open={openReceiveDialog}
				setClose={closeReceiveDialog}
				title="Are you sure you want to receive the invoice?"
				text="You can add a comment to the invoice"
				comment={comment}
				setComment={setComment}
				handleConfirm={handleReceiveConfirm}
			/>
			<ConfirmationWithCommentDialog
				open={openAddCommentDialog}
				setClose={closeAddCommentDialog}
				title="Are you sure you want to add a comment to the invoice?"
				text=""
				comment={comment}
				setComment={setComment}
				handleConfirm={handleAddCommentConfirm}
			/>
		</Box>
	);
};
